<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Titles__And__Line_Spacing"><span><span style=" font-family: Timeless; font-size: 4.00em;">NATALIA BROTHERS</span></span></p>
<p class="P_Paragraphs__And__Centre_Alignment__And__Left_Indent"><span> </span></p>
<p class="P_Paragraphs__And__Centre_Alignment__And__Left_Indent__And__Line_Spacing"><span><img alt="" src="image0.jpg" style=" max-width: 100%; max-height: 100%;"/></span></p>
<p class="P_Paragraphs__And__Centre_Alignment__And__Left_Indent"><span> </span></p>
<p class="P_Paragraphs__And__Centre_Alignment__And__Left_Indent"><span><span style=" font-family: Timeless; font-size: 1.67em;">AURAS OF NIGHT</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?7543c750